<template>
    <div class="survey-overview">
        <design-2021-apprentice-data-table
            class="survey-overview-table"
            :fields="rubricFields"
            :items="rubricsData"
            nosearch
            :show-empty="true">
            <template v-slot:cell(actions)="data">
                <b-button
                    class="btn-remove remove-icon-margin"
                    variant="danger-icon-only"
                    @click="removeRubric(data.item)">
                </b-button>
            </template>

            <template #empty="scope">
                <div class="not-found with-header attachments-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('rubrics.no_rubrics_chosen') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-survey-rubrics-overview-component',
    props: {
        value: {},
    },

    data() {
        return {
            rubricFields: [
                {
                    key: 'rubric',
                    label: 'Rubric',
                },
                {
                    key: 'skill',
                    label: this.$t('rubrics.skill'),
                },
                {
                    key: 'skillTree',
                    label: 'Set',
                },
                {
                    key: 'actions',
                    label: this.$t('rubrics.skill'),
                },
            ],

            rubrics: this.value ? this.value : [],
        };
    },

    computed: {
        rubricsData() {
            if (!this.rubrics) {
                return [];
            }

            return this.rubrics.map((rubric) => {
                return {
                    rubric: rubric.rubric.title,
                    skill: rubric.skill.name,
                    skillTreeId: rubric.skillTree.id,
                    skillTree: rubric.skillTree.name,
                    rubricId: rubric.rubric.id,
                };
            });
        },
    },

    methods: {
        removeRubric(data) {
            this.rubrics = this.rubrics.filter((rubric) => rubric.rubricId !== data.rubricId);
            this.$emit('input', this.rubrics);
            this.$emit('remove-skillTree-groups', data.skillTreeId);
        },
    },

    watch: {
        value: {
            handler: function (val) {
                this.rubrics = val;
                this.value = val;
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss"></style>
